import { render, staticRenderFns } from "./ReportContravention.vue?vue&type=template&id=10d00ccf&"
import script from "./ReportContravention.vue?vue&type=script&lang=js&"
export * from "./ReportContravention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ReportContravention.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports